// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { updatePathValidationsDrawer } from 'redux/modules/pathValidationsDrawer'

const toggleValidationsDrawer = () => (dispatch, getState) => {
  const { pathValidationsDrawer } = getState()

  const heading = pathValidationsDrawer.get('heading')
  const isOpen = pathValidationsDrawer.get('isOpen')
  const pathValidations = pathValidationsDrawer.get('pathValidations')

  // only toggle this if we have a heading or path validation messages.
  if (heading || pathValidations.size) {
    dispatch(updatePathValidationsDrawer({
      heading,
      isOpen: !isOpen,
      pathValidations,
    }))
  }
}

export default toggleValidationsDrawer
